import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import cookie from "js-cookie";
import { useRouter } from "next/router";
import config from "../../../config";

import Slider from "react-slick";
import axios from "axios";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Head from "next/head";
function CounterTopDesigns() {
  const [activeIndex, setActiveIndex] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isReadMore, setIsReadMore] = useState(false);
  const [show, setShow] = useState(false);
  const router = useRouter();
  const [isExpertTalkClicked, setIsExpertTalkClicked] = useState(false);
  const [relatedBlogData, setRelatedBlogData] = useState([]);
  const [touch, setTouch] = useState({
    name: "",
    number: "",
    pincode: cookie.get("pincode"),
    error: "",
    loading: false,
  });
  const handleShow = (image) => {
    setSelectedImage(image);
    setShow(true);
  };
  var requestOptions = {
    method: "GET",
  };
  const handleClose = () => setShow(false);
  const submitGetInTouch = async () => {
    const namee = touch.name;
    const no = touch.number;
    const pin = touch.pincode;

    if (!namee || !no || !pin) {
      setTouch({
        ...touch,
        error: "All fields are required",
      });
    } else if (String(pin).length != 6) {
      setTouch({
        ...touch,
        error: "Invalid Pincode",
      });
    } else {
      setTouch({
        ...touch,
        error: "",
        loading: true,
      });
      let response = await getIntouch({
        name: namee,
        phone: no,
        pincode: pin,
      });
      if (response?.message) {
        localStorage.setItem("leadfilled", true);
        swal(response?.message);
        setTouch({
          ...touch,
          error: "",
          loading: false,
        });
      } else {
        swal(response.data.get_in_touch.msg);
        // setGetInTouch(false)

        setTouch({
          name: "",
          number: "",
          error: "",
          loading: false,
        });
        setIsExpertTalkClicked(false);
      }
    }
  };
  const settings = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    centerMode: false,
    autoplaySpeed: 3000,
    arrows: true,
    dots: false,
    centerPadding: "0px",
    responsive: [
      {
        breakpoint: 991,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 641,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 1,
        },
      },
    ],
  };

  const settings2 = {
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    centerMode: false,
    autoplaySpeed: 3000,
    arrows: true,
    dots: false,
    centerPadding: "0px",
    responsive: [
      {
        breakpoint: 991,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 641,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 1,
        },
      },
    ],
  };

  const faqs = [
    {
      question: "What aspects should I consider while planning a bathroom?",
      answer:
        "Consider the available area, the desired overall style, ventilation, lighting, storage needs, and ventilation. Do not forget to infuse your flair into the design as well but give priority to functionality also.",
    },
    {
      question: "Can a small bathroom be made to appear bigger?",
      answer:
        "Yes, you can make a small bathroom look bigger with a few smart design choices. Using light colours like white or soft pastels can create an open feel. Large mirrors can reflect light and give an illusion of space. Opt for large tiles with fewer grout lines and install proper lighting. Keeping the décor minimal and using wall-mounted fixtures also helps to make the room feel more spacious.",
    },
    {
      question: "What are some of the recent trends in bathroom decor?",
      answer:
        "Popular trends in bathroom décor focus on creating a spa-inspired ambiance with neutral tones, natural elements, and soft lighting. Patterned or textured wall tiles paired with stylish flooring and well-placed mirrors are commonly seen. Additionally, glossy marble tiles for walls combined with matte finish tiles for floors and metallic décor elements, have become popular choices, offering a mix of elegance and contemporary style.",
    },
    {
      question: "How to select the best flooring for my bathroom?",
      answer:
        "Select flooring materials that offer resistance against moisture, such as vitrified tiles or ceramic tiles. Orientbell Tiles has a collection of anti-skid tiles that will be ideal for a bathroom. Along with the practical side, consider your design choices, maintenance requirements, and budget.",
    },
    {
      question: "Which type of lighting works the best in a bathroom?",
      answer:
        "You can go ahead with the combination of ambient, and accent lighting to make a bathroom seem cosy and well-lit. ",
    },
    {
      question:
        "Is it better to work with an expert designer or can I design my own bathroom?",
      answer:
        "Hiring a designing expert brings experience, saves time, and brings a consistent style. However, if you are on a tight budget, creating your bathroom design is achievable with careful planning and study.",
    },
  ];
  useEffect(() => {
    getRelatedBlogs();
  }, []);
  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  const text = `Your countertops play an important role in shaping the functionality and aesthetics of your space, be it your kitchen or bathroom. The right countertop design can transform your home and make everyday tasks easier. From modern styles to timeless classics, our countertop design ideas will surely leave a lasting impression.
Whether you're looking for kitchen countertop design ideas or bathroom countertop designs to enhance the look and functionality, we’ve got you covered!  We have options to match your needs for both the kitchen and bathroom. Browse our collection of countertop ideas that combine style with practicality. With these options, your space will not only be purposeful but will truly stand out.
              `;

  const maxChars = 300;
  const previewText = text.substring(0, maxChars);
  const remainingText = text.substring(maxChars);

  const getRelatedBlogs = async () => {
    // try{
    let blogQuery =
      router.asPath.split("/")[router.asPath.split("/").length - 1];
    //   let apiresult= await axios.get(`https://proxy.orientbell.com/blog/wp-json/post/v2/category/term=${blogQuery}`)
    //      console.log("RESULT OF BLOGS ", apiresult)
    //     setRelatedBlogData(apiresult)
    // }catch(err){
    //   console.log("Error in fetching blogs", err)
    // }
    fetch(
      `${config.HEADLESS_BASE_URL}/blog/wp-json/post/v2/category/term=${blogQuery}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        setRelatedBlogData(JSON.parse(result));
      })
      .catch((error) => console.log("error", error));
  };
  const scrollToElement = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const headerOffset = 100; // Adjust based on your header height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  return (
    <>
      <Head>
        <title>
          10+ Stylish Countertop Designs | Modern Kitchen Countertop Designs
        </title>

        <meta
          name="title"
          content="10+ Stylish Countertop Designs | Modern Kitchen Countertop Designs "
        />
        <meta
          name="description"
          content="Explore 10+ stunning countertop designs for kitchens and bathrooms at Orientbell. Find modern kitchen countertop designs ideas for every style and budget. "
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Home",
                  item: "https://staging.orientbell.com/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Design Ideas",
                  item: "https://staging.orientbell.com/design-ideas/",
                },
                {
                  "@type": "ListItem",
                  position: 3,
                  name: "Countertop Designs",
                  item: "https://staging.orientbell.com/design-ideas/countertop-designs",
                },
              ],
            }),
          }}
        ></script>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              url: "design-ideas/countertop-designs",
              headline: "",
              breadcrumb: "Home > Design Ideas > Countertop Designs",
              name: "10+ Stylish Countertop Designs | Modern Kitchen Countertop Designs",
              description:
                "Explore 10+ stunning countertop designs for kitchens and bathrooms at Orientbell. Find modern kitchen countertop designs ideas for every style and budget.",
            }),
          }}
        ></script>
      </Head>
      <div class="designpage-section">
        <div class="container">
          <Breadcrumb>
            <Breadcrumb.Item href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/design-ideas">
              Design Ideas
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/design-ideas/countertop-designs">
              Countertop Designs
            </Breadcrumb.Item>
          </Breadcrumb>

          <div class="designpage-heading-bx padding-spacing">
            {/* <h3>Showing {tileData.length} results for </h3> */}
            <h1>Counter Top Designs</h1>

            <p className="description-text">
              {previewText}
              {!isReadMore && text.length > maxChars && "..."}
              {isReadMore && <span>{remainingText}</span>}
              {text.length > maxChars && (
                <button onClick={toggleReadMore}>
                  {isReadMore ? "Read Less" : "Read More"}
                </button>
              )}
            </p>
          </div>
          <div class="desi-page-category-col-bx">
            <div class="design-category-head-row">
              <Slider {...settings2}>
                <div>
                  <a
                    href="#Kitchen Countertop"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToElement("Kitchen Countertop");
                    }}
                  >
                    Kitchen Countertop Design
                  </a>
                </div>
                <div>
                  <a
                    href="#Bathroom Countertop Design"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToElement("Bathroom Countertop Design");
                    }}
                  >
                    Bathroom Countertop Design
                  </a>
                </div>
                <div>
                  <a
                    href="#Other"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToElement("Other");
                    }}
                  >
                    Other Countertop Design
                  </a>
                </div>
              </Slider>
            </div>

            <div class="design-category-col-right">
              <div class="designpage-category-wrap" id="Kitchen Countertop">
                <div className="designpage-heading-row">
                  <div className="designpage-heading-left">
                    <h2>Kitchen Countertop Designs</h2>
                  </div>
                  <div className="designpage-heading-right">
                    <a href="https://staging.orientbell.com/design-ideas/countertop-designs">
                      View all
                    </a>
                  </div>
                </div>
                <div class="designpage-category-row padding-spacing">
                  <div class="designpage-category-col">
                    <div
                      class="designpage-figure"
                      onClick={() =>
                        handleShow(
                          "https://orientbell.com/media/design-images/Counter Top/Black_kitchen_countertop_design_luxurious_white_kitchen.webp"
                        )
                      }
                    >
                      <img
                        src="https://orientbell.com/media/design-images/Counter Top/Black_kitchen_countertop_design_luxurious_white_kitchen.webp"
                        alt="Black kitchen countertop design luxurious white kitchen"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Modern Bathroom design with small bathtub</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div
                      class="designpage-figure"
                      onClick={() =>
                        handleShow(
                          "https://orientbell.com/media/design-images/Counter Top/Modern_kitchen_with_a_striking_dark_stone_countertop..webp"
                        )
                      }
                    >
                      <img
                        src="https://orientbell.com/media/design-images/Counter Top/Modern_kitchen_with_a_striking_dark_stone_countertop..webp"
                        alt="Modern kitchen with a striking dark stone countertop."
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Contemporary Small Bathroom Design with Wooden countertop </h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div
                      class="designpage-figure"
                      onClick={() =>
                        handleShow(
                          "https://orientbell.com/media/design-images/Counter Top/Stylish_countertop_design_with_classic_stove_and_modern_sink.webp"
                        )
                      }
                    >
                      <img
                        src="https://orientbell.com/media/design-images/Counter Top/Stylish_countertop_design_with_classic_stove_and_modern_sink.webp"
                        alt="Stylish countertop design with classic stove and modern sink"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Modern Bathroom Design with Brown Floor Tiles</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div
                      class="designpage-figure"
                      onClick={() =>
                        handleShow(
                          "https://orientbell.com/media/design-images/Counter Top/Stylish_countertop_designs_pair_with_stylish_sink_and_cabinets.webp"
                        )
                      }
                    >
                      <img
                        src="https://orientbell.com/media/design-images/Counter Top/Stylish_countertop_designs_pair_with_stylish_sink_and_cabinets.webp"
                        alt="Stylish countertop designs pair with stylish sink and cabinets"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Modern Bathroom Design with White Wall Tiles </h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div
                      class="designpage-figure"
                      onClick={() =>
                        handleShow(
                          "https://orientbell.com/media/design-images/Counter Top/Luxurious_matte_brown_countertop_design_paired_with_neutral_cabinetry.webp"
                        )
                      }
                    >
                      <img
                        src="https://orientbell.com/media/design-images/Counter Top/Luxurious_matte_brown_countertop_design_paired_with_neutral_cabinetry.webp"
                        alt="Luxurious matte brown countertop design paired with neutral cabinetry"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Pink & White Modern Bathroom Design</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>

                  <div class="designpage-category-col">
                    <div
                      class="designpage-figure"
                      onClick={() =>
                        handleShow(
                          "https://orientbell.com/media/design-images/Counter Top/Luxury_countertop_design_featuring_with_built-in_sink_and_gas_stove.webp"
                        )
                      }
                    >
                      <img
                        src="https://orientbell.com/media/design-images/Counter Top/Luxury_countertop_design_featuring_with_built-in_sink_and_gas_stove.webp"
                        alt="Luxury countertop design featuring with built-in sink and gas stove"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Pink & White Modern Bathroom Design</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>

                  <div class="designpage-category-col">
                    <div
                      class="designpage-figure"
                      onClick={() =>
                        handleShow(
                          "https://orientbell.com/media/design-images/Counter Top/Countertop_design_paired_with_textured_wooden_cabinetry.webp"
                        )
                      }
                    >
                      <img
                        src="https://orientbell.com/media/design-images/Counter Top/Countertop_design_paired_with_textured_wooden_cabinetry.webp"
                        alt="Countertop design paired with textured wooden cabinetry"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Pink & White Modern Bathroom Design</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="designpage-category-wrap"
                id="Bathroom Countertop Design"
              >
                <div className="designpage-heading-row">
                  <div className="designpage-heading-left">
                    <h2>Bathroom Countertop Designs</h2>
                  </div>
                  <div className="designpage-heading-right">
                    <a href="https://staging.orientbell.com/design-ideas/countertop-designs">
                      View all
                    </a>
                  </div>
                </div>{" "}
                <div class="designpage-category-row padding-spacing">
                  <div class="designpage-category-col">
                    <div
                      class="designpage-figure"
                      onClick={() =>
                        handleShow(
                          "https://orientbell.com/media/design-images/Counter Top/Countertop_design_paired_with_wooden_vanity_and_marble_flooring.webp"
                        )
                      }
                    >
                      <img
                        src="https://orientbell.com/media/design-images/Counter Top/Countertop_design_paired_with_wooden_vanity_and_marble_flooring.webp"
                        alt="Countertop design paired with wooden vanity and marble flooring"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Small Bathroom design with Small Bathtub</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>

                  <div class="designpage-category-col">
                    <div
                      class="designpage-figure"
                      onClick={() =>
                        handleShow(
                          "https://staging.orientbell.com/media/design-images/Counter%20Top/Sleek_kitchen_setup_featuring_elegant_countertop_design.webp"
                        )
                      }
                    >
                      <img
                        src="https://staging.orientbell.com/media/design-images/Counter%20Top/Sleek_kitchen_setup_featuring_elegant_countertop_design.webp"
                        alt="Sleek kitchen setup featuring elegant countertop design"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Small Modern bathroom design Ideas</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="designpage-category-wrap" id="Other">
                <div className="designpage-heading-row">
                  <div className="designpage-heading-left">
                    <h2>Other Countertop Designs</h2>
                  </div>
                  <div className="designpage-heading-right">
                    <a href="https://staging.orientbell.com/design-ideas/countertop-designs">
                      View all
                    </a>
                  </div>
                </div>
                <div class="designpage-category-row padding-spacing">
                  <div class="designpage-category-col">
                    <div
                      class="designpage-figure"
                      onClick={() =>
                        handleShow(
                          "https://orientbell.com/media/design-images/Counter Top/Sophisticated_countertop_design_featuring_glossy_black_surface.webp"
                        )
                      }
                    >
                      <img
                        src="https://orientbell.com/media/design-images/Counter Top/Sophisticated_countertop_design_featuring_glossy_black_surface.webp"
                        alt="Sophisticated countertop design featuring glossy black surface"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Stylish Modern Dolphin Bathroom Design</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div
                      class="designpage-figure"
                      onClick={() =>
                        handleShow(
                          "https://orientbell.com/media/design-images/Counter Top/Office_space_with_a_sleek_white_countertop_on_conference_table_and_modern_chairs.webp"
                        )
                      }
                    >
                      <img
                        src="https://orientbell.com/media/design-images/Counter Top/Office_space_with_a_sleek_white_countertop_on_conference_table_and_modern_chairs.webp"
                        alt="Office space with a sleek white countertop on conference table and modern chairs"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Luxury Dolphin Bathroom Design</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div
                      class="designpage-figure"
                      onClick={() =>
                        handleShow(
                          "https://orientbell.com/media/design-images/Counter Top/Elegant_black_countertop_design_with_a_glossy_finish_featuring_a_modern_dining_table_setup.webp"
                        )
                      }
                    >
                      <img
                        src="https://orientbell.com/media/design-images/Counter Top/Elegant_black_countertop_design_with_a_glossy_finish_featuring_a_modern_dining_table_setup.webp"
                        alt="Elegant black countertop design with a glossy finish, featuring a modern dining table setup"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Simple Small Dolphin Bathroom Design </h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div
                      class="designpage-figure"
                      onClick={() =>
                        handleShow(
                          "https://orientbell.com/media/design-images/Counter Top/Elegant_countertop_design_with_Wooden_bar_stools.webp"
                        )
                      }
                    >
                      <img
                        src="https://orientbell.com/media/design-images/Counter Top/Elegant_countertop_design_with_Wooden_bar_stools.webp"
                        alt="Elegant countertop design with Wooden bar stools"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h3>Modern Blue & Grey Dolphin Bathroom Design</h3> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div class='designpage-detail-text padding-spacing'>
              <p>When it comes to interior ideas for a bathroom, one must balance both style and functionality. Our bathroom tile designs include categories ranging from ceramic to vitrified that not only bring great ambience but also offer practical benefits. We have a selection of tiles in diverse colours, patterns, and sizes to help you create a personalised look for your bathroom. Let us inspire your next bathroom renovation project and help you create a space that you'll adore.</p>
                <h2>Functional & Stylish Bathroom Design Idea</h2>
                <p>Making a stylish bathroom that is also functional, requires planning and some smart choices. Here's how you can maximise utility along with aesthetics in a modern bathroom design:</p>
                <ul>
                    <li>
                        <h5><strong> Space Optimisation:</strong></h5>
                        <p>Using floating vanities can create the illusion of space and also offer extra storage underneath. A characteristic of modern bathroom design is incorporating wall-mounted fixtures, which often free up floor space, giving the bathroom a larger appearance.</p>
                    </li>
                    <li>
                        <h5><strong>Storage Solutions:</strong></h5>
                        <p>
                        Maximise your bathroom space by incorporating storage options around the sink. Install shelves or cabinets beneath the sink for organising toiletries, cleaning supplies, and other essentials. In a modular bathroom design, storage options like wall hangers can be installed that are ideal for holding towels and clothes.
                        </p>
                    </li>
                    <li>
                        <h5><strong>Tile Choices: </strong></h5>
                        <p>Pick bathroom tiles that offer both functionality and style. For the floor, matte finish tiles are recommended, as they provide a practical and safe surface. You can go with vitrified tiles or the anti-skid tile range for maximum safety. For the walls, glossy finishes can add depth and interest, perfectly aligning with modern bathroom designs. We  offer a wide collection of bathroom tiles and visualisation tools to help you envision your space and guide you through the selection process.
                        </p>
                    </li>
                    <li>
                        <h5><strong>Lighting: </strong></h5>
                        <p>Layered lighting enhances function. Pendant or hanging lights can be used around the mirror for grooming or near the bathtub where ambient lighting helps create a relaxing atmosphere.</p>
                    </li>
                    <li>
                        <h5><strong>Accents and Accessories: </strong></h5>
                        <p>Bring some sophistication into the bathroom with stylish faucets, towel racks, and mirrors along with some plants for character.</p>
                    </li>
                </ul>
                 <p>These interior design ideas balance practicality with elegance, ensuring your bathroom is both a pleasure to use and a joy to look at.</p>
                
            </div>

            <div class='designpage-detail-text padding-spacing'>
                <h2>Small Bathroom Designs</h2>
                <p>A small bathroom design does not have to come at the cost of style or functionality. With careful decisions and the right material choice, a space can be created that embodies both efficiency and fashion. Below are some important elements to execute any small bathroom design you have in mind:</p>
                <ul>
                    <li>
                        <h5><strong> Type of Tiles:</strong></h5>
                        <p>Pick neutral shade tiles like beige, white or grey from Orientbell Tiles’ collection of bathroom tiles to build on an illusion of more space. Large format tiles are also perfect for small bathrooms as they reduce grout lines, making the room feel larger. </p>
                    </li>
                    <li>
                        <h5><strong>Strategic Lighting:</strong></h5>
                        <p>
                         Add some recessed lighting (lighting fixtures that get installed into the ceiling) to brighten up your bathroom. Wall sconces around mirrors to enhance any simple bathroom designs.
                        </p>
                    </li>
                    <li>
                        <h5><strong> Mirrors:</strong></h5>
                        <p>Install a frameless wall-mounted mirror that can reflect light properly to make the bathroom space feel larger. Complement the mirror area with creating an accent wall. You can use accent tiles in designs like mosaic or marble to build that look around. 
                        </p>
                    </li>
                    <li>
                        <h5><strong>Space-Saving Fixtures:  </strong></h5>
                        <p>Opt for  sink with bigger slab to maximise floor space. A floating vanity also solves storage issues.</p>
                    </li>
                    <li>
                        <h5><strong>Smart Storage:  </strong></h5>
                        <p>Make use of the space available in your bathroom with  cabinets or built-in shelves. These storage solutions can house your toiletries neatly.</p>
                    </li>
                    <li>
                        <h5><strong>Shower Design: </strong></h5>
                        <p><span> Opt for a glass shower door instead of a curtain to open up the space visually. A walk-in shower having stylish anti-skid tiles on the floor and wall tiles in colours like grey or blue can create a practical yet streamlined look.</span></p>
                    </li>
                </ul>
           
            </div>
            <div class='designpage-detail-text padding-spacing'>
                <h2>Luxury Bathroom Designs</h2>
                <p>Conceptualising your luxury bathroom design can transform your everyday routines into moments of leisure and indulgence. The following pointers will help you do the transformation:</p>
                <ul>
                    <li>
                        <h5><strong>   Decide on a Colour Palette:</strong></h5>
                        <p>Choosing what colours and shades you will follow is the foundation of the entire ambience of your bathroom. Grey, black, blue and green are some of the colours that set a luxurious tone and create a sense of elegance.</p>
                    </li>
                    <li>
                        <h5><strong> Opt for larger size tiles:</strong></h5>
                        <p>Going for larger tiles in sizes like 1200x1800 mm or 800x2400 mm creates a seamless look with minimal grout lines. This also makes your bathroom look grand.</p>
                    </li>
                    <li>
                        <h5><strong>Ambient Lighting:  </strong></h5>
                        <p>Level up with some layered lighting like sconces with cool lighting and pendant lights with warm lighting to assist you in creating that warmth and inviting ambience.</p>
                    </li>
                    <li>
                        <h5><strong>Spacious Layout: </strong></h5>
                        <p>Design an open layout with elements such as a freestanding tub or a walk-in shower with a frameless glass enclosure. Add only the finest of fixtures, which can include a rainfall showerhead, faucet—all for that ultra-luxury feel.</p>
                    </li>
                    <li>
                        <h5><strong>Accents and Accessories: </strong></h5>
                        <p>Ample Storage: Use sleek cabinets or drawers to maintain a clutter-free bathroom. Add bathroom stools for extra storage space which can be used to keep some of your toiletries or towels neatly. </p>
                    </li>
                    <li>
                        <h5><strong>Metallic Accents: </strong></h5>
                        <p>Add metallic accents through gold, bronze, or silver fixtures to bring some glam. These can be used in the faucets, cabinet handles, and lighting features, giving an extraordinary touch to your luxury bathroom design. You can pair gold fixtures with white marble tiles whereas bronze fixtures will work beautifully with blue marble tiles, adding richness and depth. Silver fixtures complement grey marble tiles or travertine tiles to bring out a modern look. </p>
                    </li>
                </ul>
               
            <p>By bringing together all of these features into your bathroom projects, you can build a luxury bathroom design that infuses fashion and functionality to deliver the ultimate peace of mind away from the hustle and bustle of daily life.</p>
            
            </div>
            <div class='designpage-detail-text padding-spacing'>
                <h2>Explore Colour Ideas for Your Bathroom Design</h2>
                <p>The right choice of colours is crucial for creating a stylish bathroom. Following are some of the best bathroom design colour ideas to consider:</p>          
                <ul>
                    <li>
                        <h5><strong> Rich Neutrals</strong></h5>
                        <p>Bathroom decor with rich neutrals like beige and cream create a cosy yet stylish look. They add warmth and elegance to your bathroom. You can use textured tiles in similar shades to keep the design consistent or go with white or grey tiles that offer a soft contrast. </p>
                    </li>
                    <li>
                        <h5><strong>Bold Accents</strong></h5>
                        <p>Add drama with bold colours like navy blue, green, or deep red. Use these shades on an accent wall and pair them with contrasting marble tiles to make a bold statement that grabs attention without feeling too intense.</p>
                    </li>
                    <li>
                        <h5><strong>Soft Pastels  </strong></h5>
                        <p>Soft pastel colours like light blue, pink, and mint green create a calming and airy atmosphere. They’re great for small bathrooms as they brighten up the space. Use white tiles in glossy finish to keep the room looking fresh and spacious.</p>
                    </li>
                    <li>
                        <h5><strong>Earthy Tones </strong></h5>
                        <p>Brown or terracotta coloured bathroom walls can create a nature-inspired look in your bathroom. Pair them with wood-look tiles or matching brown tiles to achieve a well-coordinated and inviting space.</p>
                    </li>
                    <li>
                        <h5><strong>Monochromatic Schemes </strong></h5>
                        <p>Using different shades of the same colour, like grey or white, creates a clean and modern vibe. You can mix glossy and matte tiles in these shades to keep the look interesting while ensuring everything blends together seamlessly.</p>
                    </li>
                 
                </ul>
  </div>
            <div class='designpage-detail-text padding-spacing'>
                <h2>Design Your Bathroom Interiors Based on Themes</h2>
              <p>Bathroom interior design with a theme in mind is a surefire way to let one transform a bathroom into a unified and creatively satisfying retreat. </p>            
           
            <ul>
              <li><p>For a modern bathroom, go with lightly textured bathroom tiles while playing with the neutral tones all around. Prefer sleek and simple fixtures like wall-mounted sinks and frameless mirrors to achieve the modern look. </p></li>
              <li><p>A classic, rustic bathroom interior design can have subway tiles in earthy tones and fixtures in brass or bronze. Wooden shelves and plants in stone planters can add to the rustic charm. </p></li>
              <li><p>Black and white themed bathrooms have always been in trend. To create this theme, go for classic black and white tiles, like in checkerboard pattern or choose large white tiles with sleek black borders for a modern touch. Keep fixtures in matte black finishes with white sink. </p></li>
              <li><p>A beach-themed bathroom interior might include blue, green or dolphin tiles with wooden finish furniture that evoke a sense of a soothing coastal vibe. </p></li>
              <li><p>An artistic theme lets you bring a mix of colours and patterns into your bathroom. Moroccan tiles, with their rich designs, can be the focal point on the floor or as an accent wall. Pair these with simple metal fixtures to create a lively yet balanced space. </p></li>
            </ul>
           <p>Make the interiors, tiles, colours, and accessories align with your chosen theme to build a personalised bathroom. Orientbell Tiles can be a helping hand for your tiling needs so that you have one less thing to worry about.</p>
            </div>
            <div class='designpage-detail-text padding-spacing'>
                <h2>Essentials of the Perfect Bathroom Design</h2>
                <p>A good bathroom design must seamlessly blend two things: aesthetics and function. Here's a checklist you need to check through to not miss out on any essentials:</p>
                <ul>
                    <li>
                        <h5><strong>Functionality</strong></h5>
                        <p>The perfect bathroom design skillfully combines form and function, making sure that each element fulfils a functional need while boosting the bathroom's overall visual attractiveness. Use durable and water-resistant materials that combine style with longevity. Include smart storage solutions like cabinets and shelves to keep the space organised.</p>
                    </li>
                    <li>
                        <h5><strong>Personalised style</strong></h5>
                        <p>Make your bathroom feel uniquely yours by adding design elements, colours, and accessories that match your personal taste. Add unique touches like a colourful shower curtain or custom shelving to showcase your favourite items. These choices will create a cohesive look that makes the space feel comfortable and truly yours.</p>
                    </li>
                    <li>
                        <h5><strong>Safety features </strong></h5>
                        <p>To ensure a safe bathroom, opt for anti-skid tiles to prevent slips, especially when the floor is wet. Install handles near the shower and toilet for extra support. Slip-resistant mats can help keep the floor dry. Using shower curtains or glass partitions can also minimise water splashes and enhance safety.</p>
                    </li>
                    <li>
                        <h5><strong>Easy maintenance</strong></h5>
                        <p>For easy maintenance, choose materials and finishes that are simple to clean and care for. Opt for tiles with glossy finish that resist stains, and select fixtures that require minimal maintenance. </p>
                    </li>
                    <li>
                        <h5><strong>Ventilation</strong></h5>
                        <p>Good ventilation is crucial for maintaining air quality and preventing moisture buildup in your bathroom. Proper airflow helps reduce humidity and prevents mould and mildew growth. Installing an exhaust fan or ensuring windows can open allows fresh air to circulate, keeping the space dry and comfortable.</p>
                    </li>
                </ul>
            </div>
           
            <div class='designpage-latest-design padding-spacing'>
                <h2>Get Latest Bathroom Design Ideas By Expert Designer</h2>

                <button class='talk-expert-btn talk-to-expert-design-page bottom-section' onClick={()=>{setIsExpertTalkClicked(true)}}>Talk to Expert</button>
            </div> */}

          {/* <div className='designpage-faq-section padding-spacing'>
      <h2>FAQs About Bathroom Design</h2>
      <div className="newacd designpage-faq-row">
        <ul className="accordion">
          {faqs.map((faq, index) => (
            <li key={index}>
              <a className="toggle" onClick={() => handleToggle(index)}>
                {index + 1}. {faq.question}
              </a>
              {activeIndex === index && (
                <ul className="inner">
                  <li>{faq.answer}</li>
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div> */}

          {relatedBlogData?.length > 0 && (
            <div className="tile-related-blog">
              <h2 className="title">Related Blogs</h2>
              <div className="designpage-relatedpost-row">
                <Slider {...settings}>
                  {relatedBlogData?.map((obj, index) => {
                    return (
                      <div className="related-blog-col" key={index}>
                        <div className="blog-figure">
                          <a href={obj.permalink}>
                            <img
                              src={obj.image}
                              loading="lazy"
                              alt="Marble Tiles Vs Marble Slab: What is Better for Your Home?"
                            />
                          </a>
                        </div>
                        <div className="blog-text">
                          <div className="listingDate">{obj.date}</div>
                          <div className="listingHead">
                            <a href={obj.permalink} rel="nofollow">
                              <div
                                dangerouslySetInnerHTML={{ __html: obj.title }}
                              />
                            </a>
                          </div>
                          <div className="listingText">
                            <p>
                              {" "}
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: obj.content.slice(0, -11),
                                }}
                              />
                            </p>
                            <div className="listingButton">
                              <a href={obj.permalink} rel="nofollow">
                                Read More
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Slider>
              </div>
            </div>
          )}
        </div>
      </div>

      <Modal
        className="image-zoom-view-modal"
        show={show}
        autoFocus
        onHide={handleClose}
      >
        <Modal.Dialog>
          <Modal.Header closeButton />

          {selectedImage && <img height="400px" src={`${selectedImage}`}></img>}
        </Modal.Dialog>
      </Modal>

      <Modal
        show={isExpertTalkClicked}
        className="pincode-popup-bx expert_assistance_modal ask-question-popup"
        onHide={() => {
          // setTimePopup(false)
          // setGetInTouch(false)
          setIsExpertTalkClicked(false);
          // localStorage.setItem('leadSkiped',true)
        }}
      >
        <Modal.Dialog>
          <Modal.Header closeButton>
            <Modal.Title>Get in touch with our tile expert</Modal.Title>
          </Modal.Header>
          <div className="ask-question-section">
            <div className="expert-fig-bx">
              <img src="/new-tareek.jpg" />
            </div>
            <Modal.Body>
              <h2>Ask Tile Expert</h2>
              <p>Let Experts Help You In Buying Process</p>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  submitGetInTouch();
                }}
              >
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => {
                      setTouch({
                        ...touch,
                        name: e.target.value,
                      });
                    }}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Mobile</Form.Label>

                  <Form.Control
                    type="number"
                    onChange={(e) => {
                      setTouch({
                        ...touch,
                        number: `${touch.countryCode || ""}${e.target.value}`, // Append the country code
                      });
                    }}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Pincode</Form.Label>
                  <Form.Control
                    type="number"
                    value={touch.pincode}
                    onChange={(e) => {
                      setTouch({
                        ...touch,
                        pincode: e.target.value,
                      });
                    }}
                  />
                </Form.Group>

                {touch.error && (
                  <p className="error text-danger">{touch.error}</p>
                )}

                <Button
                  variant="primary"
                  type="submit"
                  disabled={touch.loading}
                  style={{ width: "100%" }}
                >
                  {touch.loading ? "Submitting" : "Submit"}
                </Button>
              </Form>
            </Modal.Body>
          </div>
          {/* <Modal.Footer>
              <Button variant="primary" onClick={() => handlePinSave()}>
                Submit
              </Button>
            </Modal.Footer> */}
        </Modal.Dialog>
      </Modal>
    </>
  );
}

export default CounterTopDesigns;
